module.exports = __webpack_public_path__ + "img/antes_despues_208.a6e2a962.png";